module.exports = __webpack_public_path__ + "static/media/service_s4.277d4676.png";